exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Xsn97PScx-fAjmSCnyR7O{display:-webkit-box;display:-ms-flexbox;display:flex;display:-webkit-flex}html[dir=ltr] .Xsn97PScx-fAjmSCnyR7O{float:right}html[dir=rtl] .Xsn97PScx-fAjmSCnyR7O{float:left}", ""]);

// exports
exports.locals = {
	"divContainer": "Xsn97PScx-fAjmSCnyR7O"
};